import { LineType, ArrowType, APIComponentType } from '@ardoq/api-types';
import { colors } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';

export const fallbackReferenceStyle = Object.freeze({
  color: colors.black950,
  line: LineType.SOLID,
  lineEnding: ArrowType.BOTH,
  lineBeginning: ArrowType.NONE,
  svgStyle: null,
  id: -1000,
  index: 0,
  name: 'fallback-reference-type',
  returnsValue: false,
});

export const fallbackComponentType: APIComponentType = Object.freeze({
  children: {},
  color: colors.red700,
  description: null,
  icon: IconName.ERROR,
  id: 'fallback-component-type',
  image: null,
  index: 0,
  level: 0,
  name: 'Fallback Component Type',
  parent: null,
  returnsValue: false,
  shape: null,
  standard: null,
});
